import React, { useContext } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { useMutation } from "@apollo/react-hooks";
import { CUSTOMER_DELETE_REQUEST } from "@components/pages/AccountDeletePage/queries";
import { customerDeleteRequest } from "@components/pages/AccountDeletePage/__generated__/customerDeleteRequest";
import { Button } from "@src/components/atoms";
import { CredentialContext, credentialType } from "@providers";
import { useAlert } from "react-alert";

const AccountDeletePage: React.FC<IProps> = (
  {
    // destructure props here if needed
  }: IProps) => {
  const [requestCustomerDelete, {data, error, loading}] =
    useMutation<customerDeleteRequest>(CUSTOMER_DELETE_REQUEST, {
      onCompleted: () => {
        alert('Account delete requested. Please check you email inbox.');
      }
    });
  const {currentUser} = useContext<credentialType>(CredentialContext);

  const handleClick = (e: any) => {
    requestCustomerDelete({
      variables: {id: currentUser.user.id}
    });
  }

  return (
    <S.Wrapper>
      <h2>Delete My Account</h2>
      <p>If you'd like to remove your account,
        please click on the button below and
        a confirmation email will be sent to you.</p>
      <Button onClick={handleClick}>delete account</Button>
    </S.Wrapper>
  )
};

export { AccountDeletePage }